import React, { useState, useEffect, useMemo, useRef} from 'react';
import { Grid } from '@material-ui/core/';

import {
  Typography, useMediaQuery, useTheme,
} from '@material-ui/core';
import { toUnderScoreSlug} from "../../../lib/helpers/helpers";
import MarkdownEditor from "@uiw/react-markdown-editor";
import useAI from "../../../lib/hooks/useAI";
import AutoSuggest from '@avcs/autosuggest';
const ContextWriting = ({prompt, debounceQuery, setInput, input}) => {
  const theme = useTheme();
  const matchSM = useMediaQuery(theme.breakpoints.down('xs'));
  
  const [contextSummary, setContextSummary] = useState();
  const [autocompleteSummary, setAutocompleteSummary] = useState();
  const [grammerSummary, setGrammerSummary] = useState();
  
  const {isLoading: isLoadingAI, isRefetching: isRefetchingAI, data: ai, refetch: refetchAI} = useAI('writer_completion', toUnderScoreSlug(prompt), debounceQuery);
  const { response } = useMemo(()=>ai ?? [], [ai]);
  const textareaRef = useRef(null);
  
  useEffect(() => {
    if (response) {
      if (response.context && response.context.choices.length && response.context.choices[0] && response.context.choices[0].text) {
        setContextSummary(response.context.choices[0].text)
      }
      if (response.autocomplete && response.autocomplete.choices.length && response.autocomplete.choices[0] && response.autocomplete.choices[0].text) {
        setAutocompleteSummary(response.autocomplete.choices[0].text)
      }
      if (response.grammer && response.grammer.choices.length && response.grammer.choices[0] && response.grammer.choices[0].text) {
        setGrammerSummary(response.grammer.choices[0].text)
      }
    }
    }, [response]);
  
  return (
    <>
                  <Grid item xs={12}
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}>
                  <Grid item xs={matchSM ? 12 : 6}>
                    <Typography>Editor</Typography>
                    <MarkdownEditor
                       ref={textareaRef}
                       visible={true}
                       style={{minHeight:400, height:610}}
                       //value={markdown}
                       source={input}
                       onChange={(value, viewUpdate) => setInput(value)}
                    />
                  </Grid>
                  <Grid item xs={matchSM ? 12 : 6}>
                    <Grid item xs={12}
                          container
                          justifyContent="space-between"
                          alignItems="center"
                          spacing={2}>
                      <Grid item xs={6}>
                        <Typography>Suggestions</Typography>
                        <MarkdownEditor.Markdown
                           style={{height:300, overflowY:'auto'}}
                           source={autocompleteSummary}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography>Grammer Check</Typography>
                        <MarkdownEditor.Markdown
                           style={{height:300, overflowY:'auto'}}
                           source={grammerSummary}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography>Context</Typography>
                        <MarkdownEditor.Markdown
                           style={{height:300, overflowY:'auto'}}
                           source={contextSummary}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  </Grid>
    </>
  );
}

export default ContextWriting;
